import React, { useContext, useEffect, useState } from "react";
import TargetTypeCheckboxElement from "./TargetTypeCheckboxElement";
import { TargetTypeContext } from "./TargetTypeTab";
import { connect } from "react-redux";
import { changeTargetTypeElement, patchTargetTypes } from "../addRuleStoreService";
import { sortObjectsByAlphabet } from "../../../utils";
import { Pagination } from "../../../view/Pagination";
import TargetTypeOptionsSkeleton from "./TargetTypeOptionsSkeleton";

const PAGE_SIZE = 25;

function TargetTypeCheckboxSection({ targetTypes, rule, disabled, searchTerm, loading }) {

    const { targetType } = useContext(TargetTypeContext);

    const [elements, setElements] = useState([]);
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const [currentPage, setCurrentPage] = useState(0);

    const onClick = (element) => {
        changeTargetTypeElement(targetType, element, rule);
        setLastUpdated(Date.now())
    }

    useEffect(() => {
        const types = patchTargetTypes(targetType, targetTypes, rule);
        setElements(types);
        setCurrentPage(0); // reset page when type changes
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [targetType, lastUpdated, rule])

    // Reset page when search term changes
    useEffect(() => {
        setCurrentPage(0);
    }, [searchTerm]);

    // Filter by search term
    const sorted = sortObjectsByAlphabet(elements, 'name');
    const filtered = searchTerm
        ? sorted.filter(el => el.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : sorted;

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const paginated = filtered.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

    if (loading) {
        return <TargetTypeOptionsSkeleton />;
    }

    return (
        <>
            <ul className="addrules-target-grid-v2">
                {paginated.map((el, index) =>
                    <TargetTypeCheckboxElement
                        element={el}
                        key={index}
                        onClick={onClick}
                        disabled={disabled}
                    />
                )}
            </ul>

            {totalPages > 1 &&
                <Pagination
                    total={totalPages}
                    current={currentPage}
                    onClick={setCurrentPage}
                    totalRecords={filtered.length}
                />
            }
        </>
    )

}

function mapStateToProps(state) {

    const compliance = state.addRulesPage.compliance || [];
    const locations = state.addRulesPage.locations || [];
    const sectors = state.addRulesPage.sectors || [];
    // const deviceTypes = state.addRulesPage.deviceTypes || [];
    //const msbList = state.addRulesPage.msbList || [];
    const groups = state.addRulesPage.groups || [];
    //const rule = state.addRulesPage.rule || {};

    return {
        rule: state.addRulesPage.rule || {},
        //targetTypes: { compliance, locations, sectors, deviceTypes, msbList, groups }
        targetTypes: { compliance, locations, sectors, groups },
        loading: state.addRulesPage.targetTypesLoading
    };

}

export default connect(mapStateToProps)(TargetTypeCheckboxSection);
